"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _Pagination = require("@material-ui/lab/Pagination");
var _CaretLeftIcon = _interopRequireDefault(require("../_icons/CaretLeftIcon"));
var _CaretRightIcon = _interopRequireDefault(require("../_icons/CaretRightIcon"));
var _translation = require("../_utils/translation");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _pageItem;
  return {
    paginationContainer: {
      display: 'flex',
      alignItems: 'center'
    },
    pageLabel: (0, _defineProperty2.default)({
      display: 'none',
      marginRight: theme.spacing(3)
    }, theme.breakpoints.up('md'), {
      display: 'block'
    }),
    pageItem: (_pageItem = {
      borderColor: theme.palette.grey[500],
      height: 44,
      width: 44
    }, (0, _defineProperty2.default)(_pageItem, theme.breakpoints.up('md'), {
      height: 32,
      width: 32
    }), (0, _defineProperty2.default)(_pageItem, '&.selected', {
      color: theme.palette.primary.main
    }), (0, _defineProperty2.default)(_pageItem, '&.previousArrow', {
      order: 0,
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5
    }), (0, _defineProperty2.default)(_pageItem, '&.nextArrow', {
      order: 2
    }), _pageItem),
    buttonIcon: (0, _defineProperty2.default)({
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.primary.main
    }, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(12)
    }),
    buttonIconDisabled: {
      color: theme.palette.grey[500]
    },
    mobilePageLabel: (0, _defineProperty2.default)({
      order: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: "1px solid ".concat(theme.palette.grey[500]),
      padding: theme.spacing(0, 4)
    }, theme.breakpoints.up('md'), {
      display: 'none'
    })
  };
});
var Pagination = function Pagination(_ref) {
  var _selectedItem$;
  var totalCount = _ref.totalCount,
    pageSize = _ref.pageSize,
    onPageChange = _ref.onPageChange,
    _ref$siblingCount = _ref.siblingCount,
    siblingCount = _ref$siblingCount === void 0 ? 2 : _ref$siblingCount,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$showPreviousNext = _ref.showPreviousNextArrowButton,
    showPreviousNextArrowButton = _ref$showPreviousNext === void 0 ? true : _ref$showPreviousNext,
    _ref$showPaginationNu = _ref.showPaginationNumbers,
    showPaginationNumbers = _ref$showPaginationNu === void 0 ? false : _ref$showPaginationNu,
    _ref$showPageLabel = _ref.showPageLabel,
    showPageLabel = _ref$showPageLabel === void 0 ? true : _ref$showPageLabel,
    _ref$translations = _ref.translations,
    translations = _ref$translations === void 0 ? {
      page: 'Page',
      pagination: 'Page {page} of {numberOfPages}',
      goNext: 'Go to next page',
      goPrevious: 'Go to previous page'
    } : _ref$translations;
  var classes = useStyles();
  var numPages = Math.ceil(totalCount / pageSize);
  var _usePagination = (0, _Pagination.usePagination)({
      siblingCount: siblingCount,
      defaultPage: currentPage,
      count: numPages,
      hideNextButton: !showPreviousNextArrowButton,
      hidePrevButton: !showPreviousNextArrowButton,
      onChange: function onChange(e, page) {
        return onPageChange(page);
      }
    }),
    items = _usePagination.items;
  if (numPages <= 1) {
    return null;
  }
  var selectedItem = items.filter(function (item) {
    return item.selected;
  });
  var page = ((_selectedItem$ = selectedItem[0]) === null || _selectedItem$ === void 0 ? void 0 : _selectedItem$.page) || 0;
  var translationValues = {
    page: page,
    numberOfPages: numPages
  };
  var pageLabel = (0, _translation.translate)(translations.pagination, translationValues);
  return __jsx("div", {
    className: classes.paginationContainer
  }, showPageLabel && __jsx("div", {
    className: classes.pageLabel
  }, pageLabel), __jsx(_core.ButtonGroup, {
    role: "navigation",
    "aria-label": pageLabel
  }, showPageLabel && __jsx("div", {
    className: classes.mobilePageLabel
  }, pageLabel), items.map(function (item, index) {
    if (item.type === 'page' && showPaginationNumbers) {
      return __jsx(_core.Button, {
        key: index,
        className: (0, _clsx3.default)(classes.pageItem, {
          selected: item.selected
        }),
        onClick: item.onClick,
        "aria-current": item.selected ? 'page' : undefined,
        "aria-label": "".concat(translations.page, " ").concat(item.page)
      }, item.page);
    }
    if (item.type === 'previous' && showPreviousNextArrowButton) {
      return __jsx(_core.Button, {
        key: index,
        className: "previousArrow ".concat(classes.pageItem),
        onClick: item.onClick,
        disabled: item.disabled,
        "aria-label": translations.goPrevious
      }, __jsx(_CaretLeftIcon.default, {
        className: (0, _clsx3.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, item.disabled))
      }));
    }
    if ((item.type === 'end-ellipsis' || item.type === 'start-ellipsis') && showPaginationNumbers) {
      return __jsx(_core.Button, {
        key: index,
        disabled: true
      }, __jsx("span", null, "..."));
    }
    if (item.type === 'next' && showPreviousNextArrowButton) {
      return __jsx(_core.Button, {
        key: index,
        className: "nextArrow ".concat(classes.pageItem),
        onClick: item.onClick,
        disabled: item.disabled,
        "aria-label": translations.goNext
      }, __jsx(_CaretRightIcon.default, {
        className: (0, _clsx3.default)(classes.buttonIcon, (0, _defineProperty2.default)({}, classes.buttonIconDisabled, item.disabled))
      }));
    } else {
      return null;
    }
  })));
};
var _default = Pagination;
exports.default = _default;